<template>
    <div id="map">
        <l-map :zoom="zoom" :center="[13.9094, -60.9789]">
          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
          <l-geo-json  v-for="(layer, index) in layerContainer" :geojson="getGeoJson(layer)" :key="index" :options="getOptions(layer)"></l-geo-json>
        </l-map>
    </div>
</template>

<script>
  import store from '../../store.js';
  import { LMap, LTileLayer, LGeoJson, LMarker } from 'vue2-leaflet';
  import L from 'leaflet';
  import html2canvas from 'html2canvas';

    export default {
        methods: {
          getOptions: function (layer) {
            return {
                style: function () {
                return {
                  weight: 2,
                  color: '#ECEFF1',
                  opacity: 1,
                  fillColor: layer.color,
                  fillOpacity: 1
                }
              }
            }
          },
          getGeoJson: function (layer) {
            console.log('THIS IS THE LAYER THAT WAS PASSED', layer)
            return layer;
          },
          parseImage: function() {
            html2canvas(document.querySelector("#map"), {useCORS: true}).then(function(canvas) {
              // console.log(canvas);
              let link = document.createElement('a');
              link.href = canvas.toDataURL();
              // link.download = "blah.png";
              // link.click();
              // console.log(canvas.toDataURL());
            });
            // let c = document.getElementById('the_canvas_element_id');
            // let t = c.getContext('2d');
            // window.open('', document.getElementById('the_canvas_element_id').toDataURL());
            // let map = L.mapbox.map('map').setView([38.9, -77.03], 14);
            // leafletImage(map, function(err, canvas) {
            //     // now you have canvas
            //     // example thing to do with that canvas:
            //     var img = document.createElement('img');
            //     var dimensions = map.getSize();
            //     img.width = dimensions.x;
            //     img.height = dimensions.y;
            //     img.src = canvas.toDataURL();
            //     document.getElementById('images').innerHTML = '';
            //     document.getElementById('images').appendChild(img);
            // });
          }
        },
        computed: {
          layerContainer: function(){
            return store.state.layerContainer;
          },
          geoJsonOptions: function () {
            return store.state.geoJsonOptions;
          },
          geoJson: function () {
            return store.state.geoJson;
          },
          geoJsonLayers: function() {
            return store.state.geoJsonLayers;
          },
          selectedGeoJsonLayers: function () {
            return store.state.selectedGeoJsonLayers;
          },
          icon () {
            return L.icon({
              iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
              shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.3/images/marker-shadow.png',
              iconSize: [25, 41],
              iconAnchor: [12, 41],
              popupAnchor: [1, -34],
              shadowSize: [41, 41]
            })
          }
        },
        data () {
          return {
            marker: L.latLng(47.413220, -1.219482),
            options: {
              style: function () {
                return {
                  weight: 2,
                  color: '#ECEFF1',
                  opacity: 1,
                  fillColor: '#ff0000',
                  fillOpacity: 1
                }
              }
            },
            zoom:11,
            center: L.latLng(47.413220, -1.219482),
            url:'http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
            attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          }
        },
        components: {
            LMap, LTileLayer, LGeoJson, LMarker
        }
    }

</script>

<style scoped lang="scss">
    #map { height: 100%; }
</style>


// WEBPACK FOOTER //
// src/components/report/Leaflet.vue